import { render } from "./NatStep1.vue?vue&type=template&id=586beb7e&scoped=true"
import script from "./NatStep1.vue?vue&type=script&lang=js"
export * from "./NatStep1.vue?vue&type=script&lang=js"

import "../form.css?vue&type=style&index=0&id=586beb7e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586beb7e"]])

export default __exports__